// Centralized password policy for signup and password changes

export const passwordRequirementsText = 'Minimum 8 characters'

export const validatePassword = (password) => {
  if (!password || password.length < 8) {
    return { valid: false, message: 'Password must be at least 8 characters' }
  }
  return { valid: true, message: '' }
}


